module.exports = __webpack_public_path__ + "3f6fd0bf97171a297a30eda11002769a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/鸭嘴兽拖卡二维码.jpg
// module id = 1324
// module chunks = 61